import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { logger } from '../../utils/logger';
import { AuthContextType } from '../contexts/AuthContext';

const AdminInviteUser = () => {
    const [email, setEmail] = useState('');
    const [credits, setCredits] = useState(3); // Default value for credits
    const [userLevel, setUserLevel] = useState(4); // Default value for user level
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleInvite = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            // Call the Supabase Edge Function
            const { data, error } = await supabase.functions.invoke('admin_create_user', {
                body: {
                    email,
                    credits,
                    user_level: userLevel,
                },
            });

            if (error) {
                throw error;
            }

            setMessage(`Success: ${data.message}`); // Assuming the Edge Function returns a message
            logger.info('User invited successfully:', data);
        } catch (error: unknown) {
            if (error instanceof Error) {
                setMessage(`Error: ${error.message}`);
            } else {
                setMessage('An unknown error occurred');
            }
            logger.error('Invite process failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded shadow">
            <h2 className="text-2xl mb-4">Invite New User</h2>
            <form onSubmit={handleInvite}>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter email address"
                    className="w-full p-2 mb-4 border rounded"
                    required
                />
                <input
                    type="number"
                    value={credits}
                    onChange={(e) => setCredits(Number(e.target.value))}
                    placeholder="Enter credits"
                    className="w-full p-2 mb-4 border rounded"
                    required
                />
                <select
                    value={userLevel}
                    onChange={(e) => setUserLevel(Number(e.target.value))}
                    className="w-full p-2 mb-4 border rounded"
                    required
                >
                    <option value={0}>Free</option>
                    <option value={1}>Basic/Student</option>
                    <option selected value={3}>Plus</option>
                    <option value={4}>Platinum</option>
                    
                </select>
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                    {loading ? 'Sending...' : 'Send Invitation'}
                </button>
            </form>
            {message && (
                <p className={`mt-4 ${message.includes('Error') ? 'text-red-500' : 'text-green-500'}`}>
                    {message}
                </p>
            )}
        </div>
    );
};

export { AdminInviteUser };